/**
 * Pronto Posto – Maildaten · Deutsch (de-DE) · KS03
 *
 * KS03 Traumschiff – Petra Witzgold / Rafaela Silva. Postfach: raf.silva@pronto-posto.com
 *
 * Aufteilung nach language/episode: geteilte Inhalte einer Sprache leben in ./_shared.js.
 * Sprachen sind strikt getrennt – Mails dieser Datei adressieren ausschliesslich Postfaecher
 * dieser Sprache. IDs sind global eindeutig (siehe ID-Reservierungen in den Blockkommentaren).
 */
/* eslint-disable */

export function getEmails() {
    return [
        // KS03 Traumschiff Rework: Petra - Rafaela Mails


        {
            id: 15,
            from: {
                email: 'p.witzgold@pronto-posto.com',
                name: 'Petra W',
                avatar: require('@src/assets/images/portrait/petra.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'raf.silva@pronto-posto.com'
            }],
            subject: 'St. Helen – neue Story?',
            cc: [],
            bcc: [],
            message: 'Hey Rafaela,<p>ich habe auf der Arbeit gehört, dass dein Verlobter Tickets für die <b>St. Helen</b> gewonnen hat.<br><br>Erinnerst du dich noch an den Bericht über Helmstadt, an dem ich vor kurzem gearbeitet hatte?<br>Guck dir den nochmal an... Du wirst es nicht glauben, aber bei meiner damaligen Recherche bin ich auch auf den Namen <b>Jürgen Hoffmann</b> gestoßen.<br><br>Und weißt du, wer das ist? <b>DER Kapitän der St. Helen.</b><br><br>Schau dir mal die <b>HS-Nautik</b> an. Das ist die Hochschule, an der der Kapitän sein Studium absolviert haben will...<br><br>Ich will dir ja nicht vorschreiben, während deines Urlaubs zu arbeiten, aber DAS wäre schon ein glorreicher Bericht.<br><br>Gerne helfe ich dir auch, soweit ich kann, aber bitte sei vorsichtig, wo und wie du deine Recherche dokumentierst. Solche Menschen sind stets auf der Hut und gut vernetzt.<br><br>Liebe Grüße und bis morgen,<br>Petra',
            attachments: [],
            isStarred: true,
            labels: ['work'],
            time: 'Tue. Jan. 31 2023 15:43:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },

        {
            id: 16,
            from: {
                email: 'p.witzgold@pronto-posto.com',
                name: 'Petra W',
                avatar: require('@src/assets/images/portrait/petra.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'raf.silva@pronto-posto.com'
            }],
            subject: 'Re: Klabautermann?',
            cc: [],
            bcc: [],
            message: 'Hey Rafaela,<p>also das mit dem <b>Klabautermann</b> klingt eher nach Klatschpresse. Wir können doch keine Geistergeschichten veröffentlichen!<br><br>Hast du nicht vielleicht irgendwas zum Kapitän oder der Crew?',
            attachments: [],
            isStarred: false,
            labels: ['work'],
            time: 'Mon. Mar. 06 2023 10:35:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 17,
                    from: {
                        email: 'raf.silva@pronto-posto.com',
                        name: 'Rafaela S',
                        avatar: require('@src/assets/images/portrait/rafaela.png').default
                    },
                    to: [{
                        name: 'Petra W',
                        email: 'p.witzgold@pronto-posto.com'
                    }],
                    subject: 'Klabautermann?',
                    cc: [],
                    bcc: [],
                    message: 'Hallo Petra,<p>ich habe natürlich mein Notizbuch mitgenommen. Die wichtigsten Informationen bewahre ich – ganz altmodisch – darin auf. Das habe ich eigentlich immer bei mir, also mach dir keine Sorgen. Da kommt so schnell keiner dran ;) <br><br>Aber du hattest recht, irgendetwas auf diesem Schiff ist merkwürdig. Ich habe mir ein paar Notizen gemacht:<br><br><b>Klabautermann?</b><br>- Petra meint, ich soll nicht darüber schreiben, aber ich glaube, da steckt mehr dahinter.<br>- Tobias sagt: Der Geist wohnt neben ihm im Zimmer. Eine Frau mit dunklen Haaren steht immer im Flur und starrt das Zimmer an, verschwindet aber, sobald jemand kommt. → Als ich sie angesprochen habe, ist sie mir ausgewichen. Wer ist sie? Vielleicht weiß sie etwas. <br>- Träumt Tobias nur? Ich weiß nicht, ob ich daran glauben soll.<br><br><i>Danke, dass du dir Sorgen machst, Petra :)</i>',                        attachments: [],
                    isStarred: false,
                    labels: ['work'],
                    time: 'Sun. Mar. 05 2023 20:24:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },

        {
            id: 18,
            from: {
                email: 'p.witzgold@pronto-posto.com',
                name: 'Petra W',
                avatar: require('@src/assets/images/portrait/petra.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'raf.silva@pronto-posto.com'
            }],
            subject: 'Re: Weitere Notizen',
            cc: [],
            bcc: [],
            message: 'Rafaela, bitte sei vorsichtig! Lass es lieber sein, wenn es zu gefährlich wird!',
            attachments: [],
            isStarred: false,
            labels: ['work'],
            time: 'Thu. Mar. 09 2023 08:12:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 19,
                    from: {
                        email: 'raf.silva@pronto-posto.com',
                        name: 'Rafaela S',
                        avatar: require('@src/assets/images/portrait/rafaela.png').default
                    },
                    to: [{
                        name: 'Petra W',
                        email: 'p.witzgold@pronto-posto.com'
                    }],
                    subject: 'Weitere Notizen',
                    cc: [],
                    bcc: [],
                    message: 'Hallo Petra,<p>ja... da hast du vermutlich recht. Die Crew verhält sich ebenfalls sonderbar. Ich habe noch nichts Handfestes, aber mir sind ein paar Sachen aufgefallen:<br><br><b>Der Kapitän</b><br>- Interview 08.03, sehr unfreundlich, weicht meinen Fragen aus.<br>- www.hs-nautik.de<br>- Crew verliert kein negatives Wort über ihn, und er nimmt sie in Schutz – alle stecken unter einem Hut (?!)<br>- Bin beim Interview an seine Karte rangekommen. Die 01 sollte auf alle Kabinen Zugriff haben. Ich brauche sie nur kurz, dann lass ich sie wieder auftauchen. Er wird davon nichts mitbekommen.<br><br><b>Sonstiges</b><br>- Ich habe das Gefühl, immer irgendwen zu sehen, wenn ich mein Zimmer verlasse... werde ich verfolgt?<br>- Romy und Axel scheinen ein Paar zu sein<br>- Tobias meint, dass keiner ihm wegen der Lärmbelästigung im Zimmer neben ihm helfen will<br>- Axel und Romy verlangen Geld für ein Interview → bestechlich??<br>- Wollte schauen, was es mit dieser Frau auf sich hat und habe etwas Schlimmes entdeckt. Ich muss erstmal untertauchen, das wird zu gefährlich...<br><br>Es gibt auch noch ein paar andere Sachen, aber die schreibe ich lieber nur analog auf.',
                    attachments: [],
                    isStarred: false,
                    labels: ['work'],
                    time: 'Wed. Mar. 08 2023 21:03:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },
    ]
}

export function getSpam() {
    return [
        // KS03 Traumschiff Rework: Rafaela Spam Mails

        {
            id: 107,
            from: {
                email: 'offers@instant-crypto.pro',
                name: 'Instant Crypto Offers',
                avatar: require('@src/assets/images/portrait/crypto.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'raf.silva@pronto-posto.com'
            }],
            subject: 'EXKLUSIV: Verdiene 5000% in 3 Tagen!',
            cc: [],
            bcc: [],
            message: '<p>Hey,</p><p>du wurdest für unser geheimes Investment-Programm ausgewählt. Verdiene jetzt hohe Renditen in Rekordzeit – starte mit nur 100€. Melde dich bei unserem Team, um dich anzumelden.</p><br><p>Gruß,<br>Instant Crypto Offers</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Sat. Feb. 04 2023 12:12:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },

        {
            id: 108,
            from: {
                email: 'funnybiz@wunderwelt.de',
                name: 'Wunderwelt FunBiz',
                avatar: require('@src/assets/images/portrait/funbiz.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'raf.silva@pronto-posto.com'
            }],
            subject: 'Unglaublig aber Wahr!!! 😜',
            cc: [],
            bcc: [],
            message: '<p>Hey Rafaela,</p><p>Du wirst es nich glauben, aber wir haben gerade die super-duper Mega Aktion am Laufen! 😎<br>Alle die jetzt mitmachen bekommne gratis Einhorn-Sticker + ein Paket unschlagbarer Wunderbonbons.</p><p>Also warte nich zu lange sonst sind die weg, schwupp-di-wupp! 🦄🍬<br>Und psst… erzähl niemanden von meinem Geheimtip, sonst is alles vorbei!</p><br><p>Lachende Grüße,<br>Dein Wunderwelt FunBiz Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Sat. Feb. 25 2023 09:51:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },

        {
            id: 109,
            from: {
                email: 'winner@superlotto-global.com',
                name: 'SuperLotto Global',
                avatar: require('@src/assets/images/portrait/superlotto.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'raf.silva@pronto-posto.com'
            }],
            subject: 'Sie haben gewonnen!',
            cc: [],
            bcc: [],
            message: '<p>Gratulation, Rafaela!</p><p>Sie wurden als Gewinnerin unseres SuperLotto-Gewinnspiels ausgewählt. Um Ihren Gewinn zu beanspruchen, kontaktieren Sie bitte unser Support-Team und halten Sie Ihre Angaben bereit. Der Anspruch verfällt in 48 Stunden.</p><br><p>Ihr SuperLotto Global Team</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Wed. Mar. 01 2023 10:24:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
    ]
}
